import React, { ChangeEvent, useRef, useState } from 'react';
import { Button, Heading, Input, Popup, PopupSection } from '@flixbus/honeycomb-react';
import { Icon, IconCrossed } from '@flixbus/honeycomb-icons-react';
import { Asterisk } from '../../VoucherForm/Asterisk';
import styles from './upload-csv-modal.module.scss';

type UploadCSVModalProps = {
  submitting: boolean;
  reason: string;
  voucherCount: number;
  // eslint-disable-next-line no-unused-vars
  onChangeReason: (value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const UploadCSVModal: React.FC<UploadCSVModalProps> = ({
  submitting,
  reason,
  voucherCount,
  onChangeReason,
  onClose,
  onSubmit,
}) => {
  const targetRef = useRef(null);
  const [triedSubmit, setTriedSubmit] = useState(false);

  const isValid = reason.trim().length >= 10 && reason.trim().length <= 255;

  const handleConfirmClick = () => {
    setTriedSubmit(true);
    if (!isValid) return;
    onSubmit();
  };

  return (
    <Popup
      active={true}
      onOverlayClick={onClose}
      targetRef={targetRef}
      role='dialog'
      aria-labelledby='reason-input'
      aria-modal='true'
    >
      <PopupSection type='icon'>
        <Icon InlineIcon={IconCrossed} size={8} className={styles.icon} />
      </PopupSection>

      <PopupSection type='title'>
        <Heading size={2} sectionHeader flushSpace>
          Disable voucher{voucherCount > 1 ? 's' : ''}?
        </Heading>
      </PopupSection>

      <PopupSection type='content'>
        <p className={styles.paragraph}>
          You are about to disable <span className={styles.number}>{voucherCount}</span> voucher
          {voucherCount > 1 ? 's' : ''}. Do you wish to continue?
        </p>
      </PopupSection>

      <PopupSection type='content' className={styles.section}>
        <Input
          id='reason-input'
          name='reason-input'
          label={
            <>
              Comment (reason for disabling) <Asterisk />
            </>
          }
          type='text'
          value={reason}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeReason(e.target.value)}
          disabled={submitting}
          required
          infoError='Value must be between 10 and 255 characters long!'
          valid={triedSubmit ? isValid : undefined}
        />
      </PopupSection>

      <PopupSection type='actions'>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          appearance='primary'
          onClick={handleConfirmClick}
          loading={submitting}
          disabled={submitting}
        >
          Confirm
        </Button>
      </PopupSection>
    </Popup>
  );
};

export default UploadCSVModal;
